import type * as amplitude from '@amplitude/analytics-browser'
import { createContext, useContext } from 'react'

export type TrackEvent = {
  name: string
  /* eslint-disable @typescript-eslint/no-explicit-any */
  eventProps?: Record<string, any>
  eventOptions?: amplitude.Types.EventOptions
}

export type AmplitudeContextProps = {
  trackEvent: (event: TrackEvent) => void
  trackEventCloseBrowser: (event: TrackEvent) => void
}

const AmplitudeContext = createContext<AmplitudeContextProps>({
  trackEvent: () => undefined,
  trackEventCloseBrowser: () => undefined,
})

export const useAmplitude = (): AmplitudeContextProps => {
  return useContext(AmplitudeContext)
}

export default AmplitudeContext
